var map = {
	"./320x100-arsenal.jpg": "LsP1",
	"./320x100-barclays.jpg": "FIzV",
	"./320x100-bars.jpg": "k2wu",
	"./320x100-chempion_.jpg": "ff3a",
	"./320x100-euro.jpg": "mIzP",
	"./320x100-euro_.jpg": "bmFC",
	"./320x100-euro_old.jpg": "LpSF",
	"./320x100-fivb-.jpg": "QBQe",
	"./320x100-fivb.jpg": "Chwm",
	"./320x100-ittf.jpg": "564J",
	"./320x100-khl.jpg": "kM8J",
	"./320x100-liga.jpg": "XguZ",
	"./320x100-liga_.jpg": "exta",
	"./320x100-liga_old.jpg": "nDDV",
	"./320x100-nba.jpg": "9LL3",
	"./320x100-nhl.jpg": "ucpN",
	"./320x100-premier.jpg": "HEfH",
	"./320x100-premier_.jpg": "/U3c",
	"./320x100-premier_old.jpg": "xwRD",
	"./320x100-russian.jpg": "iLk2",
	"./320x100-uefa-euro-2024.jpg": "jEmx",
	"./320x100-usopen.jpg": "QHE5"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "37sa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/leagues ^\.\/320x100\-.*\.jpg$
// module id = 37sa
// module chunks = 2